import React from "react";
import { Input } from "../Helpers/Input/Input";
import Button from "../Helpers/Button/Button";
import trans from "../../utils";
import "../../Styles/Mobile/MobileLogin.css";

export default function MobileLogin({
  register,
  handleSubmit,
  isLockedOut,
  lockoutDisplay,
  switchLanguage,
  lang,
  submitAttempt,
}) {
  return (
    <div
      className="mobile-login"
      dir={lang === "ar" ? "rtl" : "ltr"}
      style={{ paddingInline: "8px" }}
    >
      <div className="mobile-login-inner">
        <div className="mobile-login-logo">
          <img
            src={`${process.env.PUBLIC_URL}/GreenMainLogo.png`}
            alt="Soft Sprint"
          />
        </div>

        <form onSubmit={handleSubmit} className="mobile-login-form">
          {isLockedOut && (
            <div className="mobile-login-lockout">
              {trans("Too many login attempts. Please try again in")}{" "}
              <strong>{lockoutDisplay}</strong>
            </div>
          )}

          <div className="mobile-login-field">
            <Input
              title={trans("Email")}
              type="email"
              placeholder={trans("Enter Your Email")}
              onBlur={register.handleBlur}
              onChange={register.handleChange}
              errors={register.errors.email}
              touched={register.touched.email}
              formstyle="login-input mobile-login-input"
              id="email"
              name="email"
              disabled={isLockedOut}
            />
          </div>

          <div className="mobile-login-field">
            <Input
              title={trans("Password")}
              type="password"
              placeholder={trans("Enter Your Password")}
              onBlur={register.handleBlur}
              onChange={register.handleChange}
              errors={register.errors.password}
              touched={register.touched.password}
              formstyle="login-input mobile-login-input"
              id="password"
              name="password"
              disabled={isLockedOut}
            />
          </div>

          <button
            type="button"
            className="mobile-login-lang-link"
            onClick={switchLanguage}
          >
            {lang === "ar" ? "English" : "العربية"}
          </button>

          <div className="mobile-login-submit">
            <Button
              text={
                isLockedOut
                  ? trans("Try again in") + " " + lockoutDisplay
                  : trans("Login")
              }
              htmlType="submit"
              type="primary"
              className="login-button mobile-login-button"
              disabled={isLockedOut}
            />
          </div>

          {submitAttempt && !register.isValid && (
            <div className="mobile-login-validation">
              {trans("Please Check Required Inputs")}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
